import React from 'react';

import { MDText } from 'i18n-react';

import { GuidePage } from '../../@types/Authors';
import { WordpressData } from '../../@types/Wordpress';
import { GuideAuthorCard } from '../GuideAuthorsContent/GuideAuthorCard/GuideAuthorCard';
import LocalTexts from '../GuideAuthorsContent/GuideAuthorsContent.text.json';

import { AuthorProfileSection } from './AuthorProfileSection/AuthorProfileSection';

import styles from './AuthorDetailsContent.module.scss';

type AuthorDetailsContentProps = {
  data: WordpressData | null;
};

const LocalT = new MDText(LocalTexts);

export const AuthorDetailsContent: React.FC<AuthorDetailsContentProps> = ({ data }) => {
  if (!data?.title) {
    return null;
  }

  const { author, content, posts, title } = data;
  const authorFirstName = title?.split(' ')[0] || LocalT.translate('author');

  return (
    <div className={styles.wrapper}>
      <AuthorProfileSection {...{ author, content, title }} />

      {posts && posts.length > 0 && (
        <>
          <hr className={styles.divider} />

          <section className={styles.guidesSection}>
            <h3 className={styles.guidesTitle}>
              {LocalT.translate('moreFrom', { authorName: authorFirstName })}
            </h3>

            <div className={styles.guidesGrid}>
              {(posts as GuidePage[]).map((guide, index) => {
                const { excerpt, slug, thumbnail, title: guideTitle } = guide;
                return (
                  <GuideAuthorCard
                    key={slug ?? index}
                    ctaLabel={LocalT.translate('individualAuthor.cta') as string}
                    ctaLink={`/sell-my-car/guides/${slug}`}
                    description={excerpt}
                    image={thumbnail}
                    size='small'
                    title={guideTitle}
                  />
                );
              })}
            </div>
          </section>
        </>
      )}
    </div>
  );
};
